
import {$idSeed} from "@util/util.js";
import Constant from "@constant/index.js";

export default class Sku{
    constructor(){
        // this.__tempId = $idSeed.newId();
        this._id = "";
        this._name = "";
        this._price = 0;
        this._count = 0;
        this._isChecked = false;
        this._img = "";
        this._disabled = false;
        this._link = "";
        this._addPrice = null;
        this._totalPrice = -1;
        this._stock = -1;
        this._maxPurchase = -1;
        //false:有效, true:无效
        this._invalid = false;
        this._purchaseEnable = true;

        this._data = null;

        //是否允许编辑数量
        this._modify_count_status = true;
        //是否允许激活状态
        this._active_status = true;
    }

    getTotalPrice(){
        //私人订制的价格和其他的不一样，需要单独处理
        return this._totalPrice == -1?this._price:this._totalPrice;
    }

    setAdditionalParent(parent){
        this._parent = parent;
    }

    init(data, parent){
        this._data = data;
        this._id = data.id;
        this._name = data.name;
        this._price = data.price.showAmount;
        this._count = data.num;
        this._isChecked = false;
        this._img = data.imgUrl;
        this._disabled = false;
        this._link = data.url;
        this._addPrice = data.addPrice?data.addPric:null;
        this._totalPrice = (parent?._parent?._deliveryPrice ? data?.xiaoji?.showAmount : data?.xiaojiNew?.showAmount) || '';
        this._stock = data.stock;              //库存
        this._maxPurchase = data.maxPurchase;//最大购买数量
        this._invalid = data.invalid;       //true:失效，false:正常
        this._marketable = data.marketable;//false:已下架，true:正常
        this._purchaseEnable = data.purchaseEnable;//true:允许选择，false:不允许

        parent && this.setAdditionalParent(parent);
    }

    getMaxBuyCount(){
        if(this._stock > this._maxPurchase){
            return this._maxPurchase;
        }
        return this._stock;
    }
}